<mat-card [ngClass]="_sideCardClasses" [style.height.px]="height">
  <mat-card-header>
    <mat-card-title *ngIf="hasTitleSection()" class="side-card-title-container">
      <div class="side-card-title" *ngIf="hasTitle()">
        {{ title | translate }}
      </div>
      <div *ngIf="hasLink()">
        <app-link
          kind="standard"
          [destination]="linkDestination"
          color="accent"
          >{{ linkText | translate }}</app-link
        >
      </div>
    </mat-card-title>
    <mat-card-subtitle *ngIf="hasSubtitle()">{{
      subtitle | translate
    }}</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content><ng-content /></mat-card-content>
</mat-card>
